/**
 * Footer - Application footer component
 *
 * Provides consistent footer across all pages with copyright and links.
 */
const Footer=()=>{
    console.log('Footer is running');
    console.log('Footer is returning footer content with copyright');
    return(
        <footer className="app-footer"role="contentinfo"aria-label="Site information">
            <div className="app-footer-container">
                <p className="app-footer-text">
                    © 2025 QreditCharge. Secure payment processing for modern applications.
                </p>
            </div>
        </footer>
    );
};
export default Footer;